module.exports = __webpack_public_path__ + "img/1.8bac2e98.svg";